export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'DRKV9GOZ9csLu29hkhLuVugbB9fVQnx9',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'DRKV9GOZ9csLu29hkhLuVugbB9fVQnx9',
        audience: 'https://crew-time/api',
    }
}